import { defineMessages } from "react-intl";

export default defineMessages({
  toggleCalendar: {
    id: "KendoDatePicker.toggleCalendar",
    defaultMessage: "Toggle calendar",
  },
  increment: {
    id: "KendoDatePicker.increment",
    defaultMessage: "Increase value",
  },
  decrement: {
    id: "KendoDatePicker.decrement",
    defaultMessage: "Decrease value",
  },
  today: {
    id: "KendoDatePicker.today",
    defaultMessage: "Today",
  },
  date: {
    id: "KendoDatePicker.date",
    defaultMessage: "Date",
  },
  time: {
    id: "KendoDatePicker.time",
    defaultMessage: "Time",
  },
  cancel: {
    id: "KendoDatePicker.cancel",
    defaultMessage: "Cancel",
  },
  set: {
    id: "KendoDatePicker.set",
    defaultMessage: "Set",
  },
  toggleDateTimeSelector: {
    id: "KendoDatePicker.toggleDateTimeSelector",
    defaultMessage: "Toggle date-time selector",
  },
  now: {
    id: "KendoDatePicker.now",
    defaultMessage: "Now",
  },
  selectNow: {
    id: "KendoDatePicker.selectNow",
    defaultMessage: "Select now",
  },
  toggleTimeSelector: {
    id: "KendoDatePicker.toggleTimeSelector",
    defaultMessage: "Toggle time selector",
  },
  toggleClock: {
    id: "KendoDatePicker.toggleClock",
    defaultMessage: "Toggle clock",
  },
  swapStartEnd: {
    id: "KendoDatePicker.swapStartEnd",
    defaultMessage: "Swap start and end values",
  },
  start: {
    id: "KendoDatePicker.start",
    defaultMessage: "Start",
  },
  end: {
    id: "KendoDatePicker.end",
    defaultMessage: "End",
  },
  separator: {
    id: "KendoDatePicker.separator",
    defaultMessage: " ",
  },
  prevView: {
    id: "KendoDatePicker.prevView",
    defaultMessage: "Navigate to previous view",
  },
  nextView: {
    id: "KendoDatePicker.nextView",
    defaultMessage: "Navigate to next view",
  },
});
